/* ════════════════════════════════════════════════════════════════════════
   SOLDATTRYCK PRISMOTOR — delad klient  v1.0  (2026-08-20)

   Ett enda ställe där butiksytorna talar med prismotorn. Produktsidans
   prisruta och Designa själv använder SAMMA fil, så att de omöjligt kan
   räkna olika: det är servern som räknar, klienten bara frågar.

   Varför en delad fil och inte två kopior: de gamla prisreglerna fanns i
   tre exemplar (kundens webbläsare, kalkylarket, adminsimulatorn) och
   gled isär. Motorn finns för att avskaffa just det.

   window.SOLDATTRYCK_PRIS sätts av Liquid före den här filen laddas:
     { url: 'https://<ref>.supabase.co/functions/v1/prismotor' }

   Publikt API (window.Prismotor):
     .redo                       — false när URL saknas; allt annat blir tyst då
     .info(cb)                   — hälsokontroll + publika inställningar
     .berakna(konfig, cb)        — POST /calculate, cachad och avdubblerad
     .kr(ore) / .krExakt(ore)    — ören → svensk kronsträng
   ════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  /* Adressen läses VID VARJE ANROP, inte en gång vid start.
     Skälet är en verklig bugg 2026-08-20: produktsidans block laddade den
     här filen FÖRE den rad som satte adressen. Klienten läste då tomt,
     satte redo = false och gömde prisrutan för alltid — helt tyst, eftersom
     "ingen adress" är ett giltigt läge och inte ett fel. Med en lat
     uppslagning spelar det ingen roll i vilken ordning skripten körs. */
  function bas() {
    var c = window.SOLDATTRYCK_PRIS || {};
    return String(c.url || '').replace(/\/+$/, '');
  }

  /* Cachen lever bara i fliken OCH bara en minut. Två skäl:
     1. Inget localStorage — ett pris ska aldrig överleva ett omladdat
        regelverk och dyka upp igen nästa vecka.
     2. Tiden matchar serverns egen regelcache (CACHE_MS = 60 s) och det
        adminpanelen lovar när den sparat: "uppdateras inom en minut". Utan
        TTL gällde det löftet bara nya besökare — en flik som stod öppen
        visade priserna från före ändringen så länge den levde. */
  var CACHE_MS = 60000;
  var svarCache = {};
  var pagang = {};
  var infoCache = null;
  var infoKo = [];
  var infoHamtas = false;

  function kr(ore) {
    if (typeof ore !== 'number' || !isFinite(ore)) return '–';
    return (Math.round(ore) / 100).toLocaleString('sv-SE', {
      minimumFractionDigits: 0, maximumFractionDigits: 0
    });
  }
  function krExakt(ore) {
    if (typeof ore !== 'number' || !isFinite(ore)) return '–';
    return (Math.round(ore) / 100).toLocaleString('sv-SE', {
      minimumFractionDigits: 2, maximumFractionDigits: 2
    });
  }

  /* Alla fel möter anroparen i samma form: ett objekt med .fel och .detalj.
     Ett nätverksfel och ett saknat prisregelfel ska hanteras likadant av den
     som ritar — skillnaden hör hemma i texten, inte i kontrollflödet. */
  function felObjekt(kod, detalj) {
    return { fel: kod, detalj: detalj, manual_review: true };
  }

  function info(cb) {
    var URL_BAS = bas();
    if (!URL_BAS) { cb(felObjekt('INGEN_URL', 'Prismotorns adress är inte ifylld i temainställningarna.')); return; }
    if (infoCache && Date.now() - infoCache.ts < CACHE_MS) { cb(infoCache.d); return; }
    infoKo.push(cb);
    if (infoHamtas) return;
    infoHamtas = true;
    fetch(URL_BAS + '/', { method: 'GET' })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        infoCache = { d: d, ts: Date.now() };
        var ko = infoKo; infoKo = []; infoHamtas = false;
        ko.forEach(function (f) { f(d); });
      })
      .catch(function (e) {
        var d = felObjekt('NATVERK', String((e && e.message) || e));
        var ko = infoKo; infoKo = []; infoHamtas = false;
        /* infoCache sätts INTE vid fel. Ett tillfälligt nätverksavbrott ska
           inte låsa fliken i "prismotorn finns inte" tills sidan laddas om. */
        ko.forEach(function (f) { f(d); });
      });
  }

  /* Nyckeln är hela konfigurationen. Två identiska frågor ska ge ett anrop,
     och en fråga som redan är på väg ska inte skickas igen — antalsknappen
     klickas snabbt, och varje klick är en ny fråga. */
  function nyckelAv(k) {
    try { return JSON.stringify(k); } catch (e) { return String(Math.random()); }
  }

  function berakna(konfig, cb) {
    var URL_BAS = bas();
    if (!URL_BAS) { cb(felObjekt('INGEN_URL', 'Prismotorns adress är inte ifylld i temainställningarna.')); return; }
    var n = nyckelAv(konfig);
    var traff = svarCache[n];
    if (traff && Date.now() - traff.ts < CACHE_MS) { cb(traff.d); return; }
    if (pagang[n]) { pagang[n].push(cb); return; }
    pagang[n] = [cb];

    fetch(URL_BAS + '/calculate', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(konfig)
    })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        /* Motorn svarar 200 även på "ingen regel finns" — felet ligger i
           kroppen, inte i statuskoden. Bara riktiga svar cachas; ett fel
           ska gå att fråga om när regeln väl är inlagd. */
        if (!d || d.fel) {
          var ko1 = pagang[n]; delete pagang[n];
          ko1.forEach(function (f) { f(d || felObjekt('TOMT_SVAR', 'Motorn svarade utan innehåll.')); });
          return;
        }
        svarCache[n] = { d: d, ts: Date.now() };
        var ko = pagang[n]; delete pagang[n];
        ko.forEach(function (f) { f(d); });
      })
      .catch(function (e) {
        var ko = pagang[n]; delete pagang[n];
        var d = felObjekt('NATVERK', String((e && e.message) || e));
        ko.forEach(function (f) { f(d); });
      });
  }

  /* Kombinationsbeställningen (2026-08-31): flera produkter, samma design,
     mängdrabatt på orderns totala antal. Samma cache- och avdubblings-
     mönster som berakna — bara en annan rutt. Är rutten inte driftsatt i
     motorn ännu svarar servern med ett fel i kroppen, och anroparen faller
     tillbaka på sin reservväg; inget låser sig. */
  function beraknaOrder(konfig, cb) {
    var URL_BAS = bas();
    if (!URL_BAS) { cb(felObjekt('INGEN_URL', 'Prismotorns adress är inte ifylld i temainställningarna.')); return; }
    var n = 'ORDER|' + nyckelAv(konfig);
    var traff = svarCache[n];
    if (traff && Date.now() - traff.ts < CACHE_MS) { cb(traff.d); return; }
    if (pagang[n]) { pagang[n].push(cb); return; }
    pagang[n] = [cb];

    fetch(URL_BAS + '/calculate-order', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(konfig)
    })
      .then(function (r) {
        /* En motor utan rutten svarar 404 med icke-JSON — gör om det till
           ett vanligt felobjekt i stället för att kasta i .json(). */
        if (r.status === 404) return { fel: 'RUTT_SAKNAS', detalj: 'Motorn saknar /calculate-order (äldre version).' };
        return r.json();
      })
      .then(function (d) {
        if (!d || d.fel) {
          var ko1 = pagang[n]; delete pagang[n];
          ko1.forEach(function (f) { f(d || felObjekt('TOMT_SVAR', 'Motorn svarade utan innehåll.')); });
          return;
        }
        svarCache[n] = { d: d, ts: Date.now() };
        var ko = pagang[n]; delete pagang[n];
        ko.forEach(function (f) { f(d); });
      })
      .catch(function (e) {
        var ko = pagang[n]; delete pagang[n];
        var d = felObjekt('NATVERK', String((e && e.message) || e));
        ko.forEach(function (f) { f(d); });
      });
  }

  /* Enkel debounce för fält som skrivs i. Ligger här så att båda ytorna
     använder samma fördröjning — 200 ms är över tangenttryckningarna men
     under det som känns trögt. */
  function fordroj(fn, ms) {
    var t = null;
    return function () {
      var self = this, arg = arguments;
      if (t) clearTimeout(t);
      t = setTimeout(function () { fn.apply(self, arg); }, ms || 200);
    };
  }

  window.Prismotor = {
    info: info,
    berakna: berakna,
    beraknaOrder: beraknaOrder,
    fordroj: fordroj,
    kr: kr,
    krExakt: krExakt,
    /* Tömmer cachen direkt i stället för att vänta ut minuten. Finns för den
       som vill se en ändring slå igenom omedelbart i en öppen flik. */
    tomCache: function () { svarCache = {}; infoCache = null; }
  };

  /* redo och url är UPPSLAG, inte värden. Läses de som fasta värden svarar de
     på hur läget såg ut när filen laddades, inte hur det ser ut när frågan
     ställs — och det var precis felet ovan. */
  Object.defineProperty(window.Prismotor, 'redo', {
    get: function () { return Boolean(bas()); }
  });
  Object.defineProperty(window.Prismotor, 'url', { get: bas });
})();